import { useEffect, useMemo } from "react";

import clsx from "clsx";
import { useEffectOnce } from "usehooks-ts";

import { useSetPageTitle } from "@/atoms/page-title-atom";
import { useCustomGoalsContext } from "@components/data/custom-goals-provider";
import { useSalesBreakdownConfigs } from "@components/data/sales-breakdown-configs";
import { LoadingSlide } from "@components/title-slide-view";
import { useUser } from "@components/user-context";
import { usePrettyLogEventPage } from "@components/v2/analytics";
import { ClicksAndViewsEnhancedModellingBanner } from "@features/clicks-and-view-enhanced-modelling/clicks-and-views-enhanced-modelling";
import { CustomMetricsProvider } from "@features/custom-metrics/hooks/custom-metrics-provider";
import { Flyout } from "@features/sales-v3";
import {
  SalesSavedViewsProvider,
  TableContent,
  TopLevelFilters,
} from "@features/sales-v3-next";
import {
  SalesPageV3NextProvider,
  useSalesPageV3NextContext,
} from "@features/sales-v3-next/sales-v3-next-provider";
import { prettyLogEvent } from "@internal/analytics";
import { Pages } from "@north-beam/nb-client-side/constants";

export const SalesV3Next = () => {
  useSetPageTitle("Sales");

  const { user } = useUser();
  const { loading: breakdownsLoading } = useSalesBreakdownConfigs();
  const { loading: customGoalsLoading } = useCustomGoalsContext();
  const isLoading = breakdownsLoading || customGoalsLoading;

  useEffect(() => {
    prettyLogEvent.visited({
      page: Pages.SALES,
      user,
    });
  }, [user]);

  return (
    <div className={clsx("bg-white min-h-[100%]", { "h-full": isLoading })}>
      {isLoading ? (
        <LoadingSlide />
      ) : (
        <CustomMetricsProvider>
          <SalesSavedViewsProvider>
            <SalesPageV3NextProvider>
              <Content />
            </SalesPageV3NextProvider>
          </SalesSavedViewsProvider>
        </CustomMetricsProvider>
      )}
    </div>
  );
};

const TopBar = () =>
  //   {
  //   chartsRef,
  //   onShowConfigurationDetailsModal,
  // }: {
  //   chartsRef: React.MutableRefObject<ChartsImperativeRef | null>;
  //   onShowConfigurationDetailsModal: () => void;
  // }
  {
    // const [topLevelFiltersContainerElRef, isMinimizedTopBarVisible] =
    //   useIntersectionObserver();

    return (
      <div>
        {/* <AnimatePresence>
          {isMinimizedTopBarVisible && <MinimizedTopBar />}
        </AnimatePresence> */}
        <div
          //  ref={topLevelFiltersContainerElRef}
          className="px-6"
        >
          <TopLevelFilters
          // chartsRef={chartsRef}
          // onShowConfigurationDetailsModal={onShowConfigurationDetailsModal}
          />
        </div>
      </div>
    );
  };

const Content = () => {
  const prettyLogEventPage = usePrettyLogEventPage();

  // const [isConfigurationDetailsModalOpen, setIsConfigurationDetailsModalOpen] =
  //   useState(false);

  // const chartsRef = useRef<ChartsImperativeRef | null>(null);

  const {
    selectedSavedView,
    dateRange,
    dateRangeInterval,
    compareDateRange,
    attributionModel,
    attributionWindow,
    accountingMode,
    timeGranularity,
    flyoutId,
    flyoutTab,
    setFlyoutId,
    setFlyoutTab,
  } = useSalesPageV3NextContext();

  useEffectOnce(() => {
    const pc = selectedSavedView.config.pageConfiguration;

    const pageContext = {
      dateRange: pc.dateRange,
      attributionModel: pc.attributionModel,
      attributionWindow: pc.attributionWindow,
      accountingMode: pc.accountingMode,
      timeGranularity: pc.timeGranularity,
      compareDateRange: pc.compareDateRange,
      breakdowns: pc.breakdowns,
      filters: pc.filters,
      savedVewId: selectedSavedView.id,
    };

    prettyLogEventPage({
      domain: "Initial state",
      action: "onMount",
      additionalActionInfo: "Initial state",
      data: {
        pageContext,
      },
    });
  });

  const flyoutConfig = useMemo(() => {
    return {
      dateRange,
      dateRangeInterval,
      compareDateRange,
      attributionModel,
      attributionWindow,
      accountingMode,
      timeGranularity,
      flyoutId,
      flyoutTab,
      setFlyoutId,
      setFlyoutTab,
    };
  }, [
    dateRange,
    dateRangeInterval,
    compareDateRange,
    attributionModel,
    attributionWindow,
    accountingMode,
    timeGranularity,
    flyoutId,
    flyoutTab,
    setFlyoutId,
    setFlyoutTab,
  ]);

  return (
    <div>
      <Flyout config={flyoutConfig} />
      <div className="pb-6 bg-white border-b border-gray-0">
        <ClicksAndViewsEnhancedModellingBanner />
        <TopBar
        // chartsRef={chartsRef}
        // onShowConfigurationDetailsModal={() => {
        //   prettyLogEventPage({
        //     domain: "PageConfiguration",
        //     action: "onClick",
        //     additionalActionInfo: "Page Configuration Modal opened",
        //   });
        //   setIsConfigurationDetailsModalOpen(true);
        // }}
        />
        <div className="px-6">
          {/* <Charts ref={chartsRef} /> */}
          <TableContent
          // isConfigurationDetailsModalOpen={isConfigurationDetailsModalOpen}
          // onCloseConfigurationDetailsModal={() => {
          //   prettyLogEventPage({
          //     domain: "PageConfiguration",
          //     action: "onClose",
          //     additionalActionInfo: "Configuration Details Modal closed",
          //   });
          //   setIsConfigurationDetailsModalOpen(false);
          // }}
          />
        </div>
      </div>
    </div>
  );
};
